// ATLAS PAGE - App Generation System
export const atlasContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    // HERO SECTION
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Developer Tools
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'title',
          text: 'Atlas',
          size: 'h1'
        },
        {
          type: 'text',
          content: 'Build mobile apps 10x faster using proven patterns and AI',
          size: 'large',
          align: 'left'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'text',
          content: 'An app generation system that accelerates mobile development by combining battle-tested architectural patterns with AI-powered code generation.'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'flex',
              gap: '16px',
              flexWrap: 'wrap'
            }}>
              <span style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: '600'
              }}>
                In Development
              </span>
            </div>
          )
        }
      ]
    },

    // OVERVIEW
    {
      id: 'overview',
      title: 'What is Atlas?',
      blocks: [
        {
          type: 'container',
          background: true,
          blocks: [
            {
              type: 'text',
              content: 'Atlas is a code generation system designed to eliminate the repetitive setup work that slows down mobile app development. Instead of starting from scratch every time, Atlas provides proven patterns and templates that you can customize for your specific needs.'
            },
            { type: 'spacer', size: 'small' },
            {
              type: 'text',
              content: 'The system integrates with Anthropic\'s Claude API to intelligently adapt patterns to your requirements, generating production-ready code that follows best practices.'
            }
          ]
        }
      ]
    },

    // FEATURES
    {
      id: 'features',
      title: 'Key Features',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '24px'
            }}>
              {[
                { icon: '🏗️', title: 'Pattern Library', desc: 'Pre-built architectural patterns for common app features' },
                { icon: '🤖', title: 'AI-Powered', desc: 'Claude API integration for intelligent code generation' },
                { icon: '📱', title: 'React Native Ready', desc: 'Optimized for React Native and Expo projects' },
                { icon: '⚡', title: 'Fast Setup', desc: 'Go from idea to working code in minutes, not hours' }
              ].map((feature, i) => (
                <div key={i} style={{
                  background: 'var(--bg-secondary)',
                  padding: '24px',
                  borderRadius: '16px',
                  border: '1px solid var(--border-color)'
                }}>
                  <div style={{ fontSize: '2rem', marginBottom: '12px' }}>{feature.icon}</div>
                  <h3 style={{ color: 'var(--text-primary)', marginBottom: '8px', fontSize: '1.1rem' }}>{feature.title}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', margin: 0 }}>{feature.desc}</p>
                </div>
              ))}
            </div>
          )
        }
      ]
    },

    // TECH STACK
    {
      id: 'tech',
      title: 'Technology Stack',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '12px'
            }}>
              {['Node.js', 'Anthropic API', 'React Native', 'TypeScript', 'CLI Tools'].map((tech, i) => (
                <span key={i} style={{
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.9rem',
                  border: '1px solid var(--border-color)'
                }}>
                  {tech}
                </span>
              ))}
            </div>
          )
        }
      ]
    }
  ],

  callToAction: {
    title: 'Explore Atlas',
    text: 'Check out the repository and start building faster',
    button: {
      text: 'View Project →',
      url: '/'
    }
  }
};
